import { Subject } from 'rxjs';

const serpToolSettingsSubject = new Subject();

export const updateSerpToolSettings = {
  update: message => serpToolSettingsSubject.next(message),
  clear: () => serpToolSettingsSubject.next(),
  get: () => serpToolSettingsSubject.asObservable()
};
